import { PlusIcon } from "@heroicons/react/24/outline";

const AddButton = ({
  label,
  className,
  onClick,
  disabled,
}: {
  label: any;
  className?: string;
  onClick?: (e) => void;
  disabled?: boolean;
}) => (
  <button
  className={`bg-slate-900 text-sm hover:bg-slate-800 w-auto inline-flex whitespace-nowrap items-center px-6 border border-transparent shadow rounded-lg text-white focus:outline-none  ${className} `}
    onClick={onClick ? onClick : null}
    disabled={disabled}
  >
    {label}
  </button>
);

export default AddButton;
